import { Component, Input } from '@angular/core';

@Component({
  selector: 'concept-attributes-card',
  templateUrl: './concept-attributes-card.component.html',
})
export class ConceptAttributesCardComponent {
  @Input() public attributes: { [key: string]: any };
  @Input() public bodyClass: string;
}
